import React, { useState } from 'react'
import { ReactComponent as PlusIcon } from 'icons/plus-16.svg'

import { ButtonItem } from '../Item'
import { CreateInlineEditor } from '../InlineEditor'

type CreateNewProjectListItemProps = {
  workspaceId: string
  placeholder?: string
  showCreateProjectEditor?: boolean
}

const CreateNewProjectButton = ({
  workspaceId,
}: CreateNewProjectListItemProps) => {
  const [createNewFolderActive, setCreateNewFolderActive] = useState(false)
  const toggleEditor = () => setCreateNewFolderActive(!createNewFolderActive)

  if (!createNewFolderActive) {
    return (
      <ButtonItem
        text="New project..."
        icon={PlusIcon}
        onClick={toggleEditor}
      />
    )
  }

  return (
    <CreateInlineEditor workspaceId={workspaceId} toggleEditor={toggleEditor} />
  )
}

export { CreateNewProjectButton }
